import React from 'react';
import './hero.less';

export default ()=>{
    return(
        <section className="hero">
            <article>
                <h1>The empower initiative</h1>
                <p>investing in humanity</p>
            </article>
        </section>
    )
}

